import { cx } from "utils";

interface BadgeProps {
  text?: string;
  className?: string;
  textColorClass?: string;
}

export default function Badge({
  text = "New",
  className,
  textColorClass = "text-gray-500",
}: BadgeProps) {
  return (
    <span
      className={cx(
        "inline-flex items-center px-2 py-0.5 text-xs font-light bg-[#d4f2df]",
        textColorClass,
        className,
      )}
    >
      {text}
    </span>
  );
}
